import { Button } from '@repo/ui/components/button';
import type { ComponentProps } from 'react';

import { desktopTerminal } from '@/desktop/bridge';

import { useReturnToTill } from './return-to-till';

/**
 * The way back as a button. Draws nothing in a browser, which has no till to go
 * back to — only on a machine the desktop shell runs.
 */
export function BackToTill(props: Omit<ComponentProps<typeof Button>, 'onClick'>) {
  const returnToTill = useReturnToTill();

  if (desktopTerminal() === null) return null;

  return <Button {...props} onClick={returnToTill} />;
}
